import React from "react";
import { Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useLang } from "@/i18n";

/* Directie-overzicht: rolprofielen × rechten. Eigenaar heeft altijd alles. */
export function RoleMatrix({ catalog = [], roles = [] }) {
  const { t, meta } = useLang();
  const lang = ["nl", "en", "ar"].includes((meta?.locale || "nl").slice(0, 2)) ? (meta.locale || "nl").slice(0, 2) : "en";
  if (!catalog.length || !roles.length) return null;
  return (
    <Card className="p-5 border-border" data-testid="role-matrix">
      <h2 className="font-semibold">{t("roleMatrix")}</h2>
      <p className="text-xs text-muted-foreground mb-3">{t("roleMatrixHint")}</p>
      <div className="overflow-x-auto">
        <table className="text-xs w-full">
          <thead><tr className="border-b border-border"><th className="text-left py-2 pr-3 font-mono uppercase tracking-widest text-[10px] text-muted-foreground">{t("permissions")}</th>{roles.map((r) => <th key={r.id} className="px-2 py-2 text-center font-semibold whitespace-nowrap" data-testid={`role-col-${r.id}`}>{r.label[lang]}</th>)}</tr></thead>
          <tbody>
            {catalog.map((s) => (
              <React.Fragment key={s.section}>
                <tr className="bg-muted/40"><td colSpan={roles.length + 1} className="py-1.5 px-2 font-semibold text-[11px] uppercase tracking-wide">{s.label}</td></tr>
                {s.perms.map((p) => (
                  <tr key={p.key} className="border-b border-border/40 hover:bg-accent/40" data-testid={`perm-row-${p.key}`}>
                    <td className="py-1.5 pr-3"><span className="text-foreground">{p.label}</span> <span className="font-mono text-[10px] text-muted-foreground">{p.key}</span></td>
                    {roles.map((r) => <td key={r.id} className="text-center">{r.perms.includes(p.key) ? <Check className="h-3.5 w-3.5 text-emerald-600 inline" /> : <span className="text-muted-foreground/30">·</span>}</td>)}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
